import type { CSSProperties } from 'react';

export const INK = '#000000';
export const DARK = '#1A2332';
export const TEAL_INK = '#0B7377';

export function paperStyle(isLoading: boolean): CSSProperties {
  return {
    background: 'white',
    width: 850,
    minHeight: isLoading ? 400 : 1100,
    margin: '0 auto',
    padding: 72,
    position: 'relative',
    overflow: 'hidden',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    color: INK,
  };
}

export const watermarkStyle: CSSProperties = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%) rotate(-25deg)',
  fontSize: 44,
  fontWeight: 700,
  color: 'rgba(18, 38, 43, 0.08)',
  whiteSpace: 'nowrap',
  pointerEvents: 'none',
  letterSpacing: 2,
};

export const boxValueStyle: CSSProperties = {
  fontSize: 14,
  fontWeight: 700,
  color: INK,
  fontVariantNumeric: 'tabular-nums',
  textAlign: 'right',
  marginTop: 4,
};